import React from "react";
import TextField from '@material-ui/core/TextField';
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";
import {Link} from "@material-ui/core";
import {showAlert} from "../../store/actions/common";
import {forgotPassword} from "../../services/authService";

const styles = theme => {
    return {
        textField: {
            width: '80%',
            marginTop: '40px',
            marginRight: '40px',
            marginLeft: '40px',
        },
        form: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column'
        },
        button: {
            color: '#fff',
            marginTop: '40px'
        },

    }

}

class LoginForm extends React.Component {
    constructor() {
        super();
        this.state = {
            'email': '',
            'password': '',
            errorEmail: ''
        }
    }

    handleChange = (e) => {
        const {name, value} = e.target;
        this.setState({[name] : value})
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit(this.state);
    }

    handleForgot = (e) => {
        if (!this.state.email) {
            this.props.dispatch(showAlert('Ошибка', 'Заполнете поле почты'));
            return ;
        }
        else {
            this.props.dispatch(forgotPassword(this.state.email))
        }
    }

    render() {
        const {classes} = this.props;
        return (
            <form className={classes.form}>

                <TextField
                    className={classes.textField}
                    label={'Email'}
                    name={'email'}
                    variant={'outlined'}
                    type={'email'}
                    onInput={this.handleChange}
                />


                <TextField
                    className={this.props.classes.textField}
                    label={'password'}
                    name={'password'}
                    variant={'outlined'}
                    type={'password'}
                    onInput={this.handleChange}
                />

                <Button variant={'contained'} color={'primary'} className={classes.button} onClick={this.handleSubmit}>
                    Вход
                </Button>

                <Link onClick={(e) => this.handleForgot(e)} style={{cursor: 'pointer'}}>
                    Забыли пароль?
                </Link>

            </form>
        );
    }
}

export default withStyles(styles)(LoginForm)